import {
	formatAsMonth,
	formatAsMonthAndYear,
	formatAsYear,
} from "../../../../../core/helpers/date-formatting-util.js";
import { newDate } from "../../../../../core/helpers/date-util.js";
import nullPeriod from "../../../../period/nullPeriod.js";
import ReportColumn from "./ReportColumn.js";

/**
 * `IncomeStatementPeriodColumn` is a specific column corresponding to the server-side IncomeStatementPeriodColumn.
 *
 * @param {period} [spec.period] - Period reflected in the column
 */
export default class IncomeStatementPeriodColumn extends ReportColumn {
	constructor({ period }) {
		super(...arguments);

		this._period = period || nullPeriod;
	}

	getHeader() {
		return this._getFormattedDate();
	}

	_getFormattedDate() {
		const startYear = formatAsYear(this._getStartDate());
		const endYear = formatAsYear(this._getEndDate());

		if (this._period.isYear) {
			if (startYear === endYear) {
				return startYear;
			}
			return `${startYear} - ${endYear}`;
		}
		const startMonth = formatAsMonth(this._getStartDate());
		const endMonth = formatAsMonth(this._getEndDate());

		if (startYear === endYear) {
			if (this._period.isMonth) {
				return formatAsMonthAndYear(this._getStartDate());
			}
			return `${startMonth} - ${endMonth} ${startYear}`;
		}
		return `${formatAsMonthAndYear(
			this._getStartDate(),
		)} - ${formatAsMonthAndYear(this._getEndDate())}`;
	}

	_getStartDate() {
		return newDate(this._period.start);
	}

	_getEndDate() {
		return newDate(this._period.end);
	}

	static getType() {
		return "IncomeStatementPeriodColumn";
	}
}
